import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, PaginationUtil } from 'src/app/common/util';
import { ButtonLoading } from 'src/app/models/button-loading.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { ClientService } from 'src/app/services/client.service';
import { ProductService } from 'src/app/services/product.service';
import { InventoryReportService } from 'src/app/services/reports/inventory-report.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { PaginationModel } from 'src/app/models/pagination.model';
import { EntryKardexResponseReport, KardexResponseReport } from 'src/app/models/cardex.model';
import { RealizationInventoryPdfResponse } from 'src/app/models/inventory.model';
import { ConfigurationInvoice, InvoiceItemModel, InvoiceTemplateModel } from 'src/app/models/invoice-template.model';
import { InvoiceType } from 'src/app/enums/invoice-type.enum';
import { TemplateInvoice } from 'src/app/templateInvoice/templateInvoice';
import { PermissionTypeEnum } from 'src/app/common/permission-enum';
import { MayeReportService } from 'src/app/services/maye-report.service';

@Component({
  selector: 'app-inventory-report',
  templateUrl: './inventory-report.component.html',
  styleUrls: ['./inventory-report.component.scss']
})
export class InventoryReportComponent implements OnInit {
  entriesKardex: EntryKardexResponseReport[] = [];
  searchKardex: string = "";
  variousReports = [{
    name: 'Libro de Ventas',
    excel: true,
    pdf: true,
    date: true
  }, {
    name: 'Ventas integradas (con afiliados)',
    excel: true,
    pdf: false,
    date: true
  }, {
    name: 'Ventas integradas (sin afiliados)',
    excel: true,
    pdf: false,
    date: true
  }, {
    name: 'Saldos de inventarios',
    excel: true,
    pdf: false,
    date: true
  }, {
    name: 'Lista de Precios',
    excel: true,
    pdf: false,
    date: false
  }, {
    name: 'Facturas Administrativas',
    excel: true,
    pdf: false,
    date: true
  }, {
    name: 'Unidades Vendidas Administrativas',
    excel: true,
    pdf: false,
    date: true
  }]
  products = [];
  currentCompany = null;
  productFilter = [];
  clients = [];
  clientFilter = [];
  startDate = '';
  endDate = '';
  month = 1;
  years = [2015];
  year = 2015;
  warehouses: WarehouseResponse[] = [];
  warehouse = 0;
  typeInv = "";
  selectedReport = 0;
  productSelected = null;
  inputs = {
    productKardex: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: '',
      color: '',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    },
    client: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: '',
      color: '',
      tooltip: 'status-warehouse',
      data: {
        id: null
      }
    }
  };
  clientSelected = null;
  warehousesAllowed: { [key: number]: boolean } = {};
  hasPermissions = false;
  btnNotAssociatedProducts = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnMoveInventory = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnFamilies = new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  btnSeasonality= new ButtonLoading("btn-success", false, "", "fa fa-file-excel");
  paginationKardex = new PaginationModel(0, 5, 0, 0, [], []);
  kardex: KardexResponseReport = null;
  permissionType = PermissionTypeEnum;
  inputsProduct = {
    product: {
      value: '',
      verified: false,
      required: false,
      message: '-',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null
    }
  };
  yearSeason: string = new Date().getFullYear().toString();
  prifitMarfinReportData = null;
  paginationProfitMargin = new PaginationModel(0, 5, 0, 0, [], []);

  existenceProductSelected: any = null;
  existenceProductFilter: any[] = [];

  existenceReportData: any[] = [];
  existenceReportWarehouses: string[] = [];
  existenceReportRows: any[] = [];

  inputsExistence = {
    product: {
      value: null,
      verified: false,
      required: false,
      message: '',
      class: '',
      color: '',
      tooltip: 'status-product',
      data: null
    }
  };
  existenceWarehouse: number = 0;

  constructor(
    private warehouseService: WarehouseService,
    private toastService: ToastrService,
    private inventoryReport: InventoryReportService,
    private productService: ProductService,
    private clientService: ClientService,
    private authService: AuthenticationService,
    private mayeReportService: MayeReportService,
    private createService: TemplateInvoice
  ) {
    const today = new Date();
    this.endDate = today.toLocaleDateString('en-CA');
    this.month = parseInt(this.endDate.split('-')[1]);
    this.year = parseInt(this.endDate.split('-')[0]);
    for (let i = 0; i < this.year - this.years[0]; i++) {
      this.years.push(2015 + i + 1);
    }
    this.startDate = today.toLocaleDateString('en-CA');
    var perms = authService.getUserPosition();
    if (perms) {
      this.hasPermissions = true;
      for (let perm of perms) {
        if (perm.warehouse != 0) {
          this.warehousesAllowed[perm.warehouse] = true;
        }
      }
    }
  }

  ngOnInit(): void {
    this.warehouseService.getWarehouseByClue('').subscribe({
      next: (response: ResponseObject) => {
        var tempWarehouses = response.data as WarehouseResponse[];
        if (this.hasPermissions) {
          tempWarehouses.forEach((temp) => {
            if (temp.id != 0 && this.warehousesAllowed[temp.id]) {
              this.warehouses.push(temp);
            }
          });
        } else {
          this.warehouses = tempWarehouses;
        }
        this.warehouses = this.warehouses.sort((a, b) => a.name.localeCompare(b.name));
        this.warehouse = this.warehouses[0].id;
        this.currentCompany = JSON.parse(this.authService.getCurrentCompany());
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener las bodegas");
      }
    })
  }


  getAverageDaysExistenceReport(type: string) {
    this.inventoryReport.getAverageExistenceReport(this.getDateLong(this.endDate), this.typeInv, this.warehouse, type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Días Promedio de Existencia Reportes " + this.endDate);
        this.toastService.success('Se ha descargado el reporte Días Promedio de Existencia Reportes');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte Días Promedio de Existencia Reportes');
      }
    });
  }

  getInvoiceSalesReport(type: string) {
    this.inventoryReport.getInvoiceSalesReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Reporte de Facturas Emitidas " + this.endDate);
        this.toastService.success('Se ha descargado el reporte de Facturas Emitidas');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte de Facturas Emitidas');
      }
    });
  }

  
  getExistenceInventoryReport(type: string): void {

    const productId = this.existenceProductSelected
      ? this.existenceProductSelected.id
      : null;

    const warehouseId = Number(this.existenceWarehouse) || null;

    if (type === 'json') {
      this.existenceReportData = [];
      this.existenceReportRows = [];
      this.existenceReportWarehouses = [];
    }

    this.inventoryReport.getExistenceInventoryReport(
      this.getDateLong(this.endDate),
      this.typeInv,
      warehouseId,
      productId,
      type
    ).subscribe({

      next: (response: ResponseObject) => {

        if (type === 'json') {

          this.existenceReportData = response.data || [];

          if (productId == null) {

            // Nuevo JSON: productos agrupados
            this.buildExistenceGroupedTable();

          } else {

            // JSON anterior: producto individual
            this.buildExistenceTable();

          }

          if (this.existenceReportData.length === 0) {
            this.toastService.info(
              'No se encontraron datos'
            );
          } else {
            this.toastService.success(
              'Se han obtenido correctamente los datos'
            );
          }

          return;
        }

        this.downloadFile(
          response.data,
          type,
          'Control de Existencias y Reportería ' +
            this.endDate
        );

        this.toastService.success(
          'Se ha descargado el reporte Control de Existencias y Reportería'
        );

      },

      error: (error: any) => {

        this.toastService.error(
          type === 'json'
            ? 'Error al obtener el reporte Control de Existencias y Reportería'
            : 'Error al descargar el reporte Control de Existencias y Reportería'
        );

      }

    });

  }


  getEntryReport(type: string) {
    this.inventoryReport.getEntryReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), this.typeInv, this.warehouse, type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Control de Entradas y Reportería " + this.endDate);
        this.toastService.success('Se ha descargado el reporte Control de Entradas y Reportería');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte Control de Entradas y Reportería');
      }
    });
  }

  getCardexReport(type: string) {
    this.kardex = null;
    this.paginationKardex.total = [];
    this.resetPagination(this.paginationKardex);
    if (this.productSelected) {
      if (this.warehouse == null || this.warehouse == undefined) {
        this.toastService.info("Ingresa una opción de Bodega");
        return;
      }
      if (this.endDate && this.startDate) {
        this.inventoryReport.getCardexInventoryReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), this.productSelected.id, this.warehouse, type).subscribe({
          next: (response: ResponseObject) => {
            if (type !== 'json') {
              this.downloadFile(response.data, type, "Kardex y Reportería " + this.endDate);
              this.toastService.success('Se ha descargado el reporte Kardex y Reportería');
            } else {
              this.kardex = response.data;
              this.kardex.startDate = this.startDate;
              this.kardex.endDate = this.endDate;
              if ((response.data as KardexResponseReport).entries.length == 0) {
                this.toastService.success("No se cuentan con datos");
              } else {
                this.toastService.success("Se han obtenido correctamente los datos");
                this.entriesKardex = (response.data as KardexResponseReport).entries;
                this.filterKardex();
              }
            }
          },
          error: (error: any) => {
            this.toastService.error('Error al ' + (type !== 'json' ? 'ver' : 'descargar') + ' el reporte Kardex y Reportería');
          }
        });
      }
    } else {
      this.toastService.info("Ingresa un producto");
    }

  }

  resetPagination(paginationTemp) {
    paginationTemp.startElement = 0;
    paginationTemp.pageIndex = 0;
    paginationTemp.lastElement = paginationTemp.pageSize;
    paginationTemp.filter = paginationTemp.total.slice(paginationTemp.startElement, paginationTemp.lastElement);
    paginationTemp.lastElement = paginationTemp.filter.length;
  }

  variousReportDownload(report: number, type: string) {
    this.variousReports[report]['download' + type] = true;
    var errorMessage = () => {
      this.toastService.error('Error al descargar el reporte ' + this.variousReports[report].name);
      this.variousReports[report]['download' + type] = null;
    }
    var successMessage = (data: any) => {
      this.downloadFile(data, type, this.variousReports[report].name + " " + this.startDate + " - " + this.endDate);
      this.variousReports[report]['download' + type] = null;
      this.toastService.success('Se ha descargado el reporte ' + this.variousReports[report].name);
    }
    switch (report) {
      case 0:
        {
          this.inventoryReport.getSalesReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), type).subscribe({
            next: (response: any) => {
              successMessage(response.data);
            },
            error: (error: any) => {
              errorMessage();
            }
          });
          break;
        }
      case 1:
        {
          this.inventoryReport.getIntegratedSaleReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), type).subscribe({
            next: (response: any) => {
              successMessage(response.data);
            },
            error: (error: any) => {
              errorMessage();
            }
          });
          break;
        }
      case 2:
        {
          this.inventoryReport.getIntegratedSaleOutReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), type).subscribe({
            next: (response: any) => {
              successMessage(response.data);
            },
            error: (error: any) => {
              errorMessage();
            }
          });
          break;
        }
      case 3:
        {
          this.inventoryReport.getInventoryBalancesReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), type, this.warehouse).subscribe({
            next: (response: any) => {
              successMessage(response.data);
            },
            error: (error: any) => {
              this.toastService.error('Error al descargar el reporte ' + this.variousReports[3].name);
            }
          });
          break;
        }
      case 4:
        {
          this.inventoryReport.getPriceListReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), type).subscribe({
            next: (response: any) => {
              successMessage(response.data);
            },
            error: (error: any) => {
              this.toastService.error('Error al descargar el reporte ' + this.variousReports[4].name);
            }
          });
          break;
        }
      case 5:
        {
          this.mayeReportService.getAdministrativeInvoicesV2(this.startDate, this.endDate, type).subscribe({
            next: (response: any) => {
              successMessage(response.data);
            },
            error: (error: any) => {
              this.toastService.error('Error al descargar el reporte ' + this.variousReports[5].name);
            }
          });
          break;
        }
      case 6:
        {
          this.mayeReportService.getAdministrativeUnitSold(this.startDate, this.endDate, type).subscribe({
            next: (response: any) => {
              successMessage(response.data);
            },
            error: (error: any) => {
              this.toastService.error('Error al descargar el reporte ' + this.variousReports[6].name);
            }
          });
          break;
        }
      default: {
        this.toastService.error("Ocurrio un error");
        break;
      }
    }
  }

  getDateLong(stringDate: string): number {
    return DateUtil.parseDateToMilliseconds(stringDate);
  }

  changeProductKardex(event: any) {
    clearTimeout(this.timeout);
    var inputValue = (event.target as HTMLInputElement).value as any;
    this.productService.getProducts(inputValue).subscribe({
      next: (response: ResponseObject) => {
        this.productFilter = response.data;
        if (this.productFilter.length == 1) {
          this.selectProduct(this.productFilter[0]);
        } else {
          if (this.inputs.productKardex.required) {
            this.inputs.productKardex.class = "fa-asterisk";
          } else {
            this.inputs.productKardex.class = "";
          }
          this.inputs.productKardex.verified = false;
          this.productSelected = null;
        }
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los productos");
      }
    })
  }
  timeout = null;
  writeProductKardex(event: any) {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value as any;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      var lowercase = inputValue ? inputValue.toLowerCase() : "";
      this.productFilter = this.products.filter((product) => {
        return (product.id + " " + product.name).toLowerCase().includes(lowercase) || product.code.toLowerCase().includes(lowercase)
          || product.barCode?.toLowerCase().includes(lowercase);
      });
      if (this.productFilter.length == 1) {
        this.selectProduct(this.productFilter[0]);
      } else {
        if (this.inputs.productKardex.required) {
          this.inputs.productKardex.class = "fa-asterisk";
        } else {
          this.inputs.productKardex.class = "";
        }
        this.inputs.productKardex.verified = false;
        this.productSelected = null;
      }
    }, 500);
  }

  selectProduct(product: any) {
    clearTimeout(this.timeout);
    this.inputs.productKardex.class = "fa-circle-check";
    this.inputs.productKardex.verified = true;
    this.inputs.productKardex.value = product.name;
    this.productSelected = product;
  }

  writeClient(event: any) {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value as any;
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.clientFilter = this.clients.filter((client) => {
        return (client.nit + " " + client.name).toLowerCase().includes(inputValue);
      });
      if (this.clientFilter.length == 1) {
        this.selectClient(this.clientFilter[0]);
      } else {
        if (this.inputs.client.required) {
          this.inputs.client.class = "fa-asterisk";
        } else {
          this.inputs.client.class = "";
        }
        this.inputs.client.verified = false;
        this.clientSelected = null;
      }
    }, 500);
  }

  selectClient(client: any) {
    clearTimeout(this.timeout);
    this.inputs.client.class = "fa-check";
    this.inputs.client.verified = true;
    this.inputs.client.value = client.nit + " - " + client.name;
    this.clientSelected = client;
  }

  showReport(report: number) {
    if (this.selectedReport == report) {
      this.productSelected = null;
      this.selectedReport = 0;
    } else {
      this.selectedReport = report;
      this.getProducts('');
      if (report == 9) {
        this.getClients();
      }
    }
  }

  getClients() {
    this.clientService.getClientsByClue('').subscribe({
      next: (response: ResponseObject) => {
        this.clients = response.data;
        this.clientFilter = this.clients;
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los clientes");
      }
    })
  }

  getTransformReport(type: string) {
    this.inventoryReport.getTransformReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), this.warehouse, type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Reportería de transferencias y transformaciones " + this.endDate);
        this.toastService.success('Se ha descargado el reporte de Reportería de transferencias y transformaciones');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte de Reportería de transferencias y transformaciones');
      }
    });
  }

  getInventoryAssociatedReport(type: string) {
    this.inventoryReport.getAssociatedReport(type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Reporte de Inventarios Asociados");
        this.toastService.success('Se ha descargado el reporte de Inventarios Asociados');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte de Inventarios Asociados');
      }
    });
  }

  getAuditInventory() {
    this.inventoryReport.getAuditInventoryPDF(this.getDateLong(this.startDate), this.getDateLong(this.endDate), this.warehouse).subscribe(
      (response: ResponseObject) => {
        var pdfData = response.data as RealizationInventoryPdfResponse;
        var buildPDFData = this.createPDFFromData(pdfData);
        this.createPDF(buildPDFData);
        this.toastService.success('Se ha descargado el pdf');
      },
      (error) => {
        this.toastService.error(error.error.message);
        this.toastService.error('Error al descargar el pdf');
      }
    );
  }

  async createPDF(invoiceData: InvoiceTemplateModel) {
    var selected = invoiceData.warehouse as WarehouseResponse;
    var template = selected.nfact < 1 || selected.nfact > 7 ? 1 : selected.nfact;
    var configurationInvoice = new ConfigurationInvoice(template, selected.fcolor, selected.scolor, selected.tcolor, selected.slogan);
    if (selected.logo) {
      this.createService.selectTemplate(configurationInvoice, invoiceData, selected.logo);
    } else {
      if (this.currentCompany) {
        if (!this.currentCompany.companyLogo.includes("/images/company-avatar2.png")) {
          this.createService.selectTemplate(configurationInvoice, invoiceData, this.currentCompany.companyLogo);
        } else {
          this.createService.selectTemplate(configurationInvoice, invoiceData, null);
        }
      } else {
        this.createService.selectTemplate(configurationInvoice, invoiceData, null);
      }
    }
  }

  createPDFFromData(pdfData: RealizationInventoryPdfResponse): InvoiceTemplateModel {
    var templateGenerated = new InvoiceTemplateModel();
    templateGenerated.warehouse = this.warehouses.find((w) => {
      return w.id == this.warehouse;
    });
    templateGenerated.type = InvoiceType.INVENTORY;
    templateGenerated.inventory.date = new Date(pdfData.date).toLocaleDateString('en-CA');
    templateGenerated.inventory.name = pdfData.userName;
    templateGenerated.inventory.warehouse = pdfData.warehouseName;
    pdfData.products.forEach(bd => {
      var toAdd = new InvoiceItemModel(bd.quantity, 0, bd.prodcutName);
      toAdd.code = bd.idProduct + "";
      templateGenerated.items.push(toAdd);
    });
    return templateGenerated;
  }

  getProjectDataReport(type: string) {
    this.inventoryReport.getProjectDataReport(type, this.getDateLong(this.startDate), this.getDateLong(this.endDate)).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Información de Bolsa de Facturas");
        this.toastService.success('Se ha descargado la Información de Bolsa de Facturas');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar la Información de Bolsa de Facturas');
      }
    });
  }

  getNotAssociatedProducts(type: string) {
    if (this.btnNotAssociatedProducts.loading) {
      return;
    }
    this.btnNotAssociatedProducts.loading = true;
    var title = "Reporte de productos no asociados";
    this.inventoryReport.getNotAssociatedProducts(type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, title);
        this.toastService.success('Se ha descargado el ' + title);
        this.btnNotAssociatedProducts.loading = false;
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el ' + title);
        this.btnNotAssociatedProducts.loading = false;
      }
    });
  }

  getSeasonalityReport(type: string) {
    this.inventoryReport.getSeasonalityReport(this.month, this.year, this.warehouse, type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Reportería y Estacionalidad " + this.endDate);
        this.toastService.success('Se ha descargado el reporte de Reportería y Estacionalidad');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte de Reportería y Estacionalidad');
      }
    })
  }

  getProfitMarginReport(type: string) {
    this.inventoryReport.getProfitMarginReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), this.productSelected ? this.productSelected.id : null, this.warehouse, type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Margen de Utilidad y Reportería " + this.endDate);
        this.toastService.success('Se ha descargado el reporte de Margen de Utilidad y Reportería');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte de Margen de Utilidad y Reportería');
      }
    })
  }

  getProfitMarginReportJson() {
    this.paginationProfitMargin.total = [];
    this.resetPagination(this.paginationProfitMargin);

    this.inventoryReport.getProfitMarginReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), this.productSelected ? this.productSelected.id : null, this.warehouse, "json").subscribe({
      next: (response: ResponseObject) => {
        this.prifitMarfinReportData = response.data;
        this.paginationProfitMargin.total = this.prifitMarfinReportData;
        this.paginationProfitMargin = PaginationUtil.reset(this.paginationProfitMargin);
      },
      error: (error: any) => {
        this.toastService.error('Error al obtener el reporte de Margen de Utilidad y Reportería');
      }
    })
  }

  getProfitMarginByClientReport(type: string) {
    this.inventoryReport.getProfitMarginByClientReport(this.getDateLong(this.startDate), this.getDateLong(this.endDate), this.productSelected ? this.productSelected.id : null, this.warehouse, this.clientSelected ? this.clientSelected.id : null, type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Margen de Utilidad por Cliente y Reportería " + this.endDate);
        this.toastService.success('Se ha descargado el reporte de Margen de Utilidad por Cliente y Reportería');
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el reporte de Margen de Utilidad por Cliente y Reportería');
      }
    })
  }

  getProducts(input: string) {
    this.productService.getProducts(input).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data;
        this.productFilter = this.products;
        this.existenceProductFilter = this.products;
      },
      error: (error: any) => {
        this.toastService.error("Error al obtener los productos");
      }
    })
  }

  downloadFile(text: string, type: string, name: string) {
    const fileBytes = Uint8Array.from(atob(text), c => c.charCodeAt(0));
    // Crea un Blob con los bytes del PDF
    var fileBlob = null;
    const downloadLink = document.createElement('a');
    if (type == 'pdf') {
      fileBlob = new Blob([fileBytes], { type: 'application/pdf' });
      downloadLink.download = name + '.pdf';
    } else {
      fileBlob = new Blob([fileBytes], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      downloadLink.download = name + '.xlsx';
    }
    const pdfUrl = URL.createObjectURL(fileBlob);
    downloadLink.href = pdfUrl;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  filterKardex() {
    var lowercase = this.searchKardex ? this.searchKardex.toLowerCase() : '';
    if (lowercase) {
      this.paginationKardex.total = this.entriesKardex.filter(k => {
        return k.document?.toLowerCase().includes(lowercase) || k.existenceTotalCost + "" == lowercase
          || k.existenceUnitCost + "" == lowercase || k.existence + "" == lowercase;
      });
    } else {
      this.paginationKardex.total = this.entriesKardex;
    }
    this.paginationKardex = PaginationUtil.reset(this.paginationKardex);
  }

  verifiedInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'product') {
      let temp: any = this.products.filter((product) =>
        product.name.toLowerCase().includes(inputValue.toLowerCase()) ||
        product.id == parseInt(inputValue)
      );
      if (temp.length === 1) {
        this.changeStatusInput(temp[0], (temp[0].barCode ? temp[0].barCode + ' - ' : '') + temp[0].name, 1, 'product');
      } else {
        this.changeStatusInput(null, null, 0, 'product');
      }
    }
  }

  handleInput(event: any, type: string) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (type === 'product') {
      clearTimeout(this.timeout);
      this.inputsProduct.product.class = "typing";
      this.timeout = setTimeout(() => {
        this.productFilter = this.products.filter((product) =>
          product.name.toLowerCase().includes(inputValue.toLowerCase()) ||
          product.id == parseInt(inputValue)
        );
        if (this.productFilter.length === 0) {
          this.changeStatusInput(null, null, 0, 'product');
        } else {
          this.inputsProduct.product.class = "bx bx-list-check";
        }
      }, 500);
    }
  }

  changeStatusInput(selected: any, newValue: string, status: number, type: string) {
    let tempInput = this.inputsProduct[type];
    tempInput.verified = status === 1;
    if (status === 1) {
      tempInput.data = selected;
      tempInput.value = newValue;
      tempInput.color = "success";
      tempInput.class = 'fa-check';
    } else {
      tempInput.data = null;
      tempInput.color = 'danger';
      tempInput.class = (status === 0) ? 'fa-xmark' : 'fa-asterisk';
    }
  }


  getFamiliesReport(type: string) {
    if (this.btnFamilies.loading) {
      return;
    }
    this.btnFamilies.loading = true;

    this.inventoryReport.getFamiliesReport(type).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Conjunto de Familias de Producto" + this.endDate);
        this.toastService.success('Se ha descargado el archivo');
        this.btnFamilies.loading = false;
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el archivo');
        this.btnFamilies.loading = false;
      }
    });
  }

  getGeneralSeasonalityProduct(type: string) {
    if (this.btnSeasonality.loading) {
      return;
    }
    this.btnSeasonality.loading = true;

    const selectedProducts = this.products.filter(p => p.selected);
    const selectedIds = selectedProducts.map(p => p.id);

    if (!this.validateInputs(selectedIds)){
      this.btnSeasonality.loading = false;
      return;
    }

    let selectedWarehouseIds: number[] = [];

    if (!this.warehouse || this.warehouse.toString().trim() === '') {
      selectedWarehouseIds = this.warehouses.map(w => w.id);
    } else {
      selectedWarehouseIds = [Number(this.warehouse)];
    }


    const request = {
      year : this.yearSeason,
      productIds: selectedIds,
      warehouseIds: selectedWarehouseIds
    };


    console.log(request);

    

    this.btnSeasonality.loading = false;

    this.inventoryReport.getGeneralSeasonality(type,request).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Estacionalidad General " + this.endDate);
        this.toastService.success('Se ha descargado el archivo');
        this.btnSeasonality.loading = false;
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el archivo');
        this.btnSeasonality.loading = false;
      }
    });
  }

  getMoveInventory(type: string) {
    if (this.btnMoveInventory.loading) {
      return;
    }
    this.btnMoveInventory.loading = true;

    const selectedProducts = this.products.filter(p => p.selected);
    const selectedIds = selectedProducts.map(p => p.id);

    if (!this.validateInputs(selectedIds)){
      this.btnMoveInventory.loading = false;
      return;
    }

    const request = {
        startDate: this.startDate,
        endDate: this.endDate,
        productIds: selectedIds
      };
    this.inventoryReport.getMoveInventory(type,request).subscribe({
      next: (response: ResponseObject) => {
        this.downloadFile(response.data, type, "Movimiento de Inventario " + this.endDate);
        this.toastService.success('Se ha descargado el archivo');
        this.btnMoveInventory.loading = false;
      },
      error: (error: any) => {
        this.toastService.error('Error al descargar el archivo');
        this.btnMoveInventory.loading = false;
      }
    });
  }

  validateInputs(selectedIds:any){
    if(selectedIds.length <= 0){
      this.toastService.error("Debe seleccionar almenos un producto para realizar la busqueda");
      return false;
    }
    if(this.startDate == null || this.startDate == undefined){
      this.toastService.error("Debe seleccionar la fecha de inicio para realizar la busqueda");
      return false;
    }
    if(this.endDate == null || this.endDate == undefined){
      this.toastService.error("Debe seleccionar la fecha de fin para realizar la busqueda");
      return false;
    }
    return true;
  }

  showExistenceReport(): void {
    if (this.selectedReport === 4) {
      this.selectedReport = 0;
      return;
    }

    this.selectedReport = 4;

    if (!this.products || this.products.length === 0) {
      this.getProducts('');
    } else {
      this.existenceProductFilter = this.products;
    }
  }

  writeExistenceProduct(event: any): void {
    const inputField = event.target as HTMLInputElement;
    const inputValue = inputField.value || '';
    clearTimeout(this.timeout);

    if (!inputValue.trim()) {
      this.existenceProductSelected = null;
      this.inputsExistence.product.value = null;
      this.inputsExistence.product.data = null;
      this.inputsExistence.product.verified = false;
      this.inputsExistence.product.class = '';
      this.existenceProductFilter = this.products;
      return;
    }

    this.timeout = setTimeout(() => {

      const value = inputValue.toLowerCase();

      this.existenceProductFilter = this.products.filter((product: any) => {
        return (
          product.name?.toLowerCase().includes(value) ||
          product.code?.toLowerCase().includes(value) ||
          product.barCode?.toLowerCase().includes(value) ||
          product.id?.toString().includes(value)
        );
      });

      this.existenceProductSelected = null;
      this.inputsExistence.product.verified = false;

    }, 300);
  }

  selectExistenceProduct(product: any): void {
    if (!product) {
      this.existenceProductSelected = null;
      this.inputsExistence.product.value = null;
      this.inputsExistence.product.data = null;
      this.inputsExistence.product.verified = false;
      return;
    }

    this.existenceProductSelected = product;

    this.inputsExistence.product.value = product.name;
    this.inputsExistence.product.data = product;
    this.inputsExistence.product.verified = true;
    this.inputsExistence.product.class = 'fa-circle-check';
  }

  buildExistenceTable(): void {

    this.existenceReportWarehouses = [];
    this.existenceReportRows = [];

    if (!this.existenceReportData?.length) {
      return;
    }

    this.existenceReportWarehouses = [
      ...new Set(
        this.existenceReportData
          .map((item: any) => item.warehouseName)
          .filter((warehouse: string) => !!warehouse)
      )
    ] as string[];

    const productsMap = new Map<string, any>();

    this.existenceReportData.forEach((item: any) => {

      const key =
        item.productCode ??
        item.productBarCode ??
        item.productName;

      if (!productsMap.has(key)) {
        productsMap.set(key, {
          productCode: item.productCode,
          productName: item.productName,
          warehouses: {},
          total: 0
        });
      }

      const product = productsMap.get(key);

      const existence = Number(item.existence ?? 0);

      product.warehouses[item.warehouseName] =
        (product.warehouses[item.warehouseName] ?? 0)
        + existence;

      product.total += existence;
    });

    this.existenceReportRows =
      Array.from(productsMap.values());
  }


  buildExistenceGroupedTable(): void {

    this.existenceReportWarehouses = [];
    this.existenceReportRows = [];

    if (!this.existenceReportData?.length) {
      return;
    }

    // Bodegas disponibles en el reporte
    const selectedWarehouse = Number(this.existenceWarehouse);

    const warehouseList = this.warehouses.filter(w =>
      !selectedWarehouse || Number(w.id) === selectedWarehouse
    );

    // Mapa para identificar las bodegas por ID
    const warehouseMap = new Map<string, string>();

    warehouseList.forEach(w => {
      warehouseMap.set(String(w.id), w.name);
    });

    // Columnas dinámicas
    this.existenceReportWarehouses = warehouseList.map(
      w => w.name
    );

    // Transformar respuesta agrupada del backend
    this.existenceReportRows = this.existenceReportData.map(
      (item: any) => {

        const warehouses: { [key: string]: number } = {};

        // Inicializar todas las bodegas en cero
        this.existenceReportWarehouses.forEach(name => {
          warehouses[name] = 0;
        });

        // Convertir los IDs de bodega a nombres
        Object.keys(item.warehouses || {}).forEach(id => {

          const warehouseName = warehouseMap.get(String(id));

          if (warehouseName) {
            warehouses[warehouseName] += Number(
              item.warehouses[id] ?? 0
            );
          }

        });

        return {
          productId: item.productId,
          productCode: item.productCode,
          productName: item.productName,
          productBarCode: item.productBarCode,
          productTypeName: item.productTypeName,
          productCategoryName: item.categoryName,
          warehouses: warehouses,
          total: this.existenceReportWarehouses.reduce(
            (sum, name) => sum + warehouses[name],
            0
          )
        };

      }
    );

  }

  

}
